import { Bean, SortOrder } from '@dreryk/react-common';

import { FormsTemplateListItem, FormsTemplateSortItemsFn } from './FormsTemplates.types';
import { EMPTY_TEMPLATE_ID } from './list/FormsTemplatesListItemsRenderer';

export const createEmptyTemplate = (): FormsTemplateListItem<Bean> => ({
   id: EMPTY_TEMPLATE_ID,
});

export const isItemEmpty = <ITEM extends Bean>(item: FormsTemplateListItem<ITEM> | undefined): boolean =>
   Boolean(item?.id === EMPTY_TEMPLATE_ID);

export const sortWithEmptyItemsLast = <ITEM extends Bean>(
   items: FormsTemplateListItem<ITEM>[],
   sortOrder: SortOrder,
   sortFn: FormsTemplateSortItemsFn<ITEM>
): FormsTemplateListItem<ITEM>[] => {
   const filledItems: FormsTemplateListItem<ITEM>[] = [];
   const emptyItems: FormsTemplateListItem<ITEM>[] = [];
   items.forEach((item) => (isItemEmpty(item) ? emptyItems : filledItems).push(item));
   return [...sortFn(filledItems, sortOrder), ...emptyItems];
};
